import React from "react";
import ReactDOM from "react-dom/client";
import { IntlProvider } from "react-intl";
import LicensingApp from "./app/LicensingApp";
import { default as appconfig } from "./config.json";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import "@esri/calcite-components/dist/calcite/calcite.css";
import { AuthProvider } from "./components/AuthProvider";

//setAssetPath(window.location.href);
//setAssetPath("https://unpkg.com/@esri/calcite-components/dist/calcite/assets");

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <React.StrictMode>
        <AuthProvider>
            <IntlProvider locale={navigator.language} defaultLocale="en-GB">
                <LicensingApp
                    portalUrl={appconfig.portalUrl}
                    productIds={appconfig.productIds}
                    subProductIds={appconfig.subProductIds}
                    licenseUrl={appconfig.licenseUrl}
                    mediaUrl={appconfig.mediaUrl}
                    cdnMediaUrl={appconfig.cdnMediaUrl}
                />
            </IntlProvider>
        </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
